import Head from 'next/head';

interface IWebsiteSchemaProps {
  name: string;
  url: string;
}

export default function WebsiteSchema({ name, url }: IWebsiteSchemaProps) {
  const schemaWebsite = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    name,
    url,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaWebsite) }}
      />
    </Head>
  );
}
